import {Localizer} from "../../../infrastructure/localization/localizer";
import React from "react";
import {EmblaIcon} from "../../../core/components/emblaIcon/emblaIcon";
import {EmblaIcons} from "../../../core/emblaIcons";
import classNames from "classnames";

type ManglerVejlederUkoCellProps = {
    antalVejledere: number;
}
export const ManglerVejlederUkoCell = ({antalVejledere}: ManglerVejlederUkoCellProps) => {

    return (
        <>
            <div
                className={classNames("flex-align-c badge badge-pill padding-xs", antalVejledere > 0 && "badge-danger-light")}>
                <div className={"flex-center margin-right-xs"}>
                    <EmblaIcon iconName={antalVejledere > 0 ? EmblaIcons.Danger : EmblaIcons.Tasks}
                               additionalClasses={classNames("margin-right-xs", antalVejledere > 0 && "danger")}
                               size={"medium"}/>
                    <b className={classNames(antalVejledere > 0 ? "danger-dark" : "text-black-50")}>
                        {antalVejledere} {Localizer.dashboard_manglerVejleder()}
                    </b>
                </div>
            </div>
        </>
    );
};
